export const allTutors = [
  // Mathematics
  {
    name: 'Rohan Verma',
    qualifications: 'B.Tech IT, 8 Years Experience',
    subjects: ['Mathematics', 'High School', 'Intermediate'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '8 Yrs Exp',
    locations: ['Hazratganj', 'Mahanagar'],
    gender: 'Male',
    classes: ['Class 9-10', 'Class 11-12'],
    badge: null,
  },
  {
    name: 'Amit Tiwari',
    qualifications: 'M.Sc. Physics, IIT-JEE Mentor',
    subjects: ['Mathematics', 'Science', 'Intermediate'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '10 Yrs Exp',
    locations: ['Gomti Nagar Extension', 'Jankipuram'],
    gender: 'Male',
    classes: ['Class 11-12', 'IIT-JEE'],
    badge: 'IIT Expert',
  },
  {
    name: 'Rahul Mishra',
    qualifications: 'B.Tech CSE, Maths & Coding Expert',
    subjects: ['Mathematics', 'Coding / IT', 'High School'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '7 Yrs Exp',
    locations: ['Indira Nagar', 'Chinhat'],
    gender: 'Male',
    classes: ['Class 6-8', 'Class 9-10'],
    badge: null,
  },
  {
    name: 'Deepak Srivastava',
    qualifications: 'M.Sc. Mathematics, 12 Years',
    subjects: ['Mathematics', 'Intermediate', 'High School'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '12 Yrs Exp',
    locations: ['Gomti Nagar', 'Aliganj'],
    gender: 'Male',
    classes: ['Class 9-10', 'Class 11-12'],
    badge: null,
  },
  // Science
  {
    name: 'Anjali Sharma',
    qualifications: 'B.Sc, Maths & Science Expert',
    subjects: ['Science', 'Mathematics', 'Junior Wing'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '5 Yrs Exp',
    locations: ['Gomti Nagar', 'Indira Nagar'],
    gender: 'Female',
    classes: ['Class 1-5', 'Class 6-8'],
    badge: null,
  },
  {
    name: 'Pooja Singh',
    qualifications: 'M.Sc. Zoology, NEET Expert',
    subjects: ['Science', 'Intermediate'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '6 Yrs Exp',
    locations: ['Aliganj', 'Vibhuti Khand'],
    gender: 'Female',
    classes: ['Class 11-12', 'NEET'],
    badge: 'NEET Expert',
  },
  {
    name: 'Vikram Pandey',
    qualifications: 'M.Sc. Chemistry, NEET Specialist',
    subjects: ['Science', 'Intermediate'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '6 Yrs Exp',
    locations: ['Mahanagar', 'Hazratganj'],
    gender: 'Male',
    classes: ['Class 11-12', 'NEET'],
    badge: 'NEET Expert',
  },
  {
    name: 'Kavita Rai',
    qualifications: 'B.Sc. Biology, Science Tutor',
    subjects: ['Science', 'High School', 'Junior Wing'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '4 Yrs Exp',
    locations: ['Kalyanpur', 'Aashiana'],
    gender: 'Female',
    classes: ['Class 6-8', 'Class 9-10'],
    badge: null,
  },
  // English
  {
    name: 'Neha Gupta',
    qualifications: 'B.Ed, English & Social Studies',
    subjects: ['English', 'Junior Wing', 'High School'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '4 Yrs Exp',
    locations: ['Kalyanpur', 'Aashiana'],
    gender: 'Female',
    classes: ['Class 1-5', 'Class 6-8', 'Class 9-10'],
    badge: null,
  },
  {
    name: 'Sneha Agarwal',
    qualifications: 'M.A. English Literature, IELTS Trainer',
    subjects: ['English', 'Intermediate'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '9 Yrs Exp',
    locations: ['Rajajipuram', 'Alambagh'],
    gender: 'Female',
    classes: ['Class 11-12', 'College / Degree'],
    badge: null,
  },
  {
    name: 'Ritu Shukla',
    qualifications: 'B.Ed, English Communication Expert',
    subjects: ['English', 'Junior Wing'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '5 Yrs Exp',
    locations: ['Indira Nagar', 'Mahanagar'],
    gender: 'Female',
    classes: ['Nursery - KG', 'Class 1-5'],
    badge: null,
  },
  // Commerce
  {
    name: 'Sunita Yadav',
    qualifications: 'B.Sc. Economics & Accounts',
    subjects: ['Commerce', 'Intermediate', 'High School'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '5 Yrs Exp',
    locations: ['Sarojini Nagar', 'Aliganj'],
    gender: 'Female',
    classes: ['Class 9-10', 'Class 11-12'],
    badge: null,
  },
  {
    name: 'Manish Gupta',
    qualifications: 'M.Com, CA Finalist, Accounts Expert',
    subjects: ['Commerce', 'Intermediate'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '11 Yrs Exp',
    locations: ['Hazratganj', 'Gomti Nagar'],
    gender: 'Male',
    classes: ['Class 11-12', 'College / Degree'],
    badge: null,
  },
  {
    name: 'Prerna Mishra',
    qualifications: 'MBA Finance, Business Studies',
    subjects: ['Commerce', 'High School'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '6 Yrs Exp',
    locations: ['Aliganj', 'Vibhuti Khand'],
    gender: 'Female',
    classes: ['Class 9-10'],
    badge: null,
  },
  // Junior Wing
  {
    name: 'Priya Srivastava',
    qualifications: 'M.A. Hindi, Language Expert',
    subjects: ['Junior Wing', 'English', 'High School'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '9 Yrs Exp',
    locations: ['Rajajipuram', 'Alambagh'],
    gender: 'Female',
    classes: ['Class 1-5', 'Class 6-8'],
    badge: null,
  },
  {
    name: 'Meena Tripathi',
    qualifications: 'B.Ed Primary Education Specialist',
    subjects: ['Junior Wing'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '7 Yrs Exp',
    locations: ['Indira Nagar', 'Chinhat'],
    gender: 'Female',
    classes: ['Nursery - KG', 'Class 1-5'],
    badge: null,
  },
  {
    name: 'Archana Singh',
    qualifications: 'M.Ed, Child Psychology & Teaching',
    subjects: ['Junior Wing'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1544723795-3fb6469f5b39?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '8 Yrs Exp',
    locations: ['Gomti Nagar', 'Mahanagar'],
    gender: 'Female',
    classes: ['Nursery - KG', 'Class 1-5'],
    badge: null,
  },
  // High School
  {
    name: 'Sanjay Dubey',
    qualifications: 'M.Sc. Physics, 14 Years Exp',
    subjects: ['High School', 'Intermediate', 'Science'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1542178243-bc20204b769f?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '14 Yrs Exp',
    locations: ['Jankipuram', 'Kalyanpur'],
    gender: 'Male',
    classes: ['Class 9-10', 'Class 11-12'],
    badge: null,
  },
  {
    name: 'Anita Verma',
    qualifications: 'B.Ed, All Subjects Class 6–10',
    subjects: ['High School', 'Junior Wing'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1502685104226-ee32379fefbe?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '6 Yrs Exp',
    locations: ['Aliganj', 'Sarojini Nagar'],
    gender: 'Female',
    classes: ['Class 6-8', 'Class 9-10'],
    badge: null,
  },
  // Intermediate / IIT-JEE
  {
    name: 'Vivek Sharma',
    qualifications: 'B.Tech, PCM Expert for Class 11–12',
    subjects: ['Intermediate', 'Mathematics', 'Science'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1463453091185-61582044d556?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '9 Yrs Exp',
    locations: ['Gomti Nagar', 'Hazratganj'],
    gender: 'Male',
    classes: ['Class 11-12', 'IIT-JEE'],
    badge: 'IIT Expert',
  },
  {
    name: 'Nidhi Rao',
    qualifications: 'M.Sc. Biology, Class 11–12 Specialist',
    subjects: ['Intermediate', 'Science'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1536766820879-059fec98ec0a?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '5 Yrs Exp',
    locations: ['Vibhuti Khand', 'Gomti Nagar'],
    gender: 'Female',
    classes: ['Class 11-12', 'NEET'],
    badge: 'NEET Expert',
  },
  // Coding / IT
  {
    name: 'Arjun Khanna',
    qualifications: 'B.Tech CSE, Python & Web Dev',
    subjects: ['Coding / IT', 'Mathematics'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '6 Yrs Exp',
    locations: ['Indira Nagar', 'Gomti Nagar'],
    gender: 'Male',
    classes: ['Class 6-8', 'Class 9-10', 'Class 11-12'],
    badge: null,
  },
  {
    name: 'Suresh Patel',
    qualifications: 'MCA, Java & C++ Expert',
    subjects: ['Coding / IT'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1522556189639-b150ed9c4330?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '8 Yrs Exp',
    locations: ['Mahanagar', 'Aliganj'],
    gender: 'Male',
    classes: ['Class 9-10', 'Class 11-12', 'College / Degree'],
    badge: null,
  },
  {
    name: 'Priya Nair',
    qualifications: 'B.Tech IT, Full-Stack & AI Basics',
    subjects: ['Coding / IT', 'Mathematics'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '4 Yrs Exp',
    locations: ['Hazratganj', 'Chinhat'],
    gender: 'Female',
    classes: ['Class 6-8', 'Class 9-10', 'Class 11-12'],
    badge: null,
  },
  // Added Tutors to cover missing locations
  {
    name: 'Simran Kaur',
    qualifications: 'B.Sc. Mathematics, 5 Years Exp',
    subjects: ['Mathematics', 'Science', 'Junior Wing'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '5 Yrs Exp',
    locations: ['Alamnagar', 'LDA Colony', 'Charbagh', 'Aashiana'],
    gender: 'Female',
    classes: ['Class 1-5', 'Class 6-8'],
    badge: null,
  },
  {
    name: 'Mohit Agarwal',
    qualifications: 'B.Tech Mechanical, Science Expert',
    subjects: ['Science', 'Mathematics', 'High School'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '6 Yrs Exp',
    locations: ['Aishbagh', 'Vikas Khand', 'Omaxe City'],
    gender: 'Male',
    classes: ['Class 9-10'],
    badge: null,
  },
  {
    name: 'Kriti Singh',
    qualifications: 'M.A. English, TGT',
    subjects: ['English', 'Junior Wing', 'High School'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '7 Yrs Exp',
    locations: ['Vigyan Khand', 'Vishesh Khand', 'Tedhi Puliya'],
    gender: 'Female',
    classes: ['Class 1-5', 'Class 6-8', 'Class 9-10'],
    badge: null,
  },
  {
    name: 'Tarun Pandey',
    qualifications: 'M.Com, Accounts Specialist',
    subjects: ['Commerce', 'Intermediate'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '8 Yrs Exp',
    locations: ['Sadar Bazaar', 'Nakkhas', 'Polytechnic Chauraha'],
    gender: 'Male',
    classes: ['Class 11-12'],
    badge: null,
  },
  {
    name: 'Pooja Joshi',
    qualifications: 'B.Ed, All Subjects',
    subjects: ['Junior Wing', 'Science', 'Mathematics'],
    rating: 5,
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=150&q=80',
    verified: true,
    exp: '4 Yrs Exp',
    locations: ['Campbell Road', 'Khadra'],
    gender: 'Female',
    classes: ['Class 1-5', 'Class 6-8'],
    badge: null,
  }
];